/* eslint-disable */
export default function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0

  if (ret !== void 0) {
    return !!ret
  }

  if (objA === objB) {
    return true
  }

  if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
    return false
  }

  var keysA = Object.keys(objA)
  var keysB = Object.keys(objB)

  if (keysA.length !== keysB.length) {
    return false
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB)

  // Test for A's keys different from B.
  // biome-ignore lint/correctness/noInnerDeclarations: TODO
  for (var idx = 0; idx < keysA.length; idx++) {
    // biome-ignore lint/correctness/noInnerDeclarations: TODO
    var key = keysA[idx]

    if (!bHasOwnProperty(key)) {
      return false
    }

    // biome-ignore lint/correctness/noInnerDeclarations: TODO
    var valueA = objA[key]
    // biome-ignore lint/correctness/noInnerDeclarations: TODO
    var valueB = objB[key]

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false
    }
  }

  return true
}
